<div mat-dialog-title class="fx-layout-row fx-align--x-center">
  <h2>Upload Disclaimer</h2>
  <div class="fx-flex-grow"></div>
  @if (data.closeMethod == 'x') {
    <button mat-icon-button mat-dialog-close tabindex="-1">
      <mat-icon svgIcon="x"></mat-icon>
    </button>
  }
</div>
<mat-dialog-content>
  <p>
    The image(s) you upload here are meant to help visualize a preview of
    the final product & will only be used for that purpose.
  </p>
  <p>
    <strong>No print will be provided with your order.</strong>
  </p>
</mat-dialog-content>
<mat-dialog-actions class="fx-layout-row fx-align--space-between-x">
  <button mat-flat-button color="primary">
    <mbnm-uploader [disclaimerAccepted]="true"
      (uploadComplete)="onUploadComplete($event)"
      (uploadFailed)="onUploadFailed($event)"
      [acceptedFileTypes]="acceptedFileTypes"
      [allowMultiple]="allowMultiple"
      [uploadPath]="uploadPath">
      Accept & Upload
    </mbnm-uploader>
  </button>
  <button color="secondary" mat-flat-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>
